















import {Vue, Component} from 'vue-property-decorator';

@Component
export default class NetworkProblem extends Vue {

  public hasBeenOffline: boolean = false;
  public isOnline: boolean = true;


  created() {
    window.addEventListener('offline', () => {
      this.hasBeenOffline = true;
      this.isOnline = false;
    });

    this.isOnline = navigator.onLine;
    if (!this.isOnline) this.hasBeenOffline = true;

    window.addEventListener('online', () => {
      this.isOnline = true;
    });
  }
  updatePage() {
    window.location.reload(); // TODO: Dans l'idéal il faudrait actualisé que la vue, mais pas simple
  }
}

